<template>
    <div>
        <div class='wrap-logo'>
            <img :alt="$t('receipt.logo')" id="logo" src="./../assets/logo.png">
        </div>
        <template v-if="showContent">
            <Loader idVal="wrap-loader" v-if="isLoading" />

            <p class='title' v-if="!isLoading">{{ $t('receipt.your-order') }}</p>

            <div class="receipt-content" v-if="!isLoading">
                <div class='receipt' v-html="receipt_content" />
            </div>

            <div class="download-btn" @click="downloadFile();" v-if="!isLoading">
                <i class="ri-download-2-line"></i>
                {{ $t("receipt.download")}}
            </div>
        </template>

        <template v-if="error">
            <div class="contain-error">
                <img :alt="$t('error-page.error')" src="./../assets/api-error.png">
                <span v-html="errorContent"></span>
            </div>
        </template>

        <AlertModal v-show="isAlertModalVisible" @close="closeAlertModal" :title="alertTitle" :content="alertContent" :continue_btn="false" ref="alertDialog" />
    </div>
</template>

<script>
    //import $ from 'jquery'
    import axios from 'axios'
    import notificationService from './../notificationService'

    import Loader from './Loader.vue'
    import AlertModal from './AlertModal.vue'
    
    export default {
        name: 'Receipt',
        components: {
            AlertModal,
            Loader
        },
        data() {
            return {
                error: false,                
                alertTitle: "",
                isLoading: true,
                alertContent: "",
                errorContent: "",
                showContent: true,
                receipt_object: [],
                receipt_content: "",
                isAlertModalVisible: false
            }
        },
        mounted() { 
            this.alertTitle = this.$t('alert-modal.alert');
            let post_data = {tenant: localStorage.getItem("receipt_tenant"), params: localStorage.getItem("receipt_params")}; 

            axios.post(process.env.VUE_APP_ENDPOINT_URL +"/getSmartReceipt", post_data).then(response => {                 

                if(response.data.data.data.length == 0 || response.data.data.data.length > 1) {
                    return this.$parent.error = true;
                }

                this.receipt_content = this.nl2br(response.data.data.data[0].text.replaceAll("\\n","\n"));
                this.receipt_content = this.receipt_content.replaceAll("?", "&nbsp;"); /* -----------> CHECK TO MANTAIN */

                this.receipt_object = this.getReceiptObject(response.data.data.data[0].objects);
                this.isLoading = false;

            }).catch(err => { 
                this.manageRequestException(err.response.data.message);

                this.errorContent = this.$t("error-page.api-error");
                this.showContent = false;
                setTimeout(()=>{ 
                    this.error = true;
                }, 1000);
            });
        },
        methods: {
            closeAlertModal () {
                this.isAlertModalVisible = false;
            },
            getReceiptObject(obj_arr) {
                let out = null; 
                if(obj_arr.length == 1) {
                    out = obj_arr[0];

                    return out;
                }

                for(let i=0; i<obj_arr.length; i++) {
                    if(obj_arr[i].is_receipt) {
                        out = obj_arr[i];

                        return out;
                    }
                }

                return null;
            },
            nl2br (str, is_xhtml) {
                if (typeof str === 'undefined' || str === null) {
                    return '';
                }
                var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
                return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
            },
            downloadFile() { 
                let tenant = localStorage.getItem("receipt_tenant");
                let post_data = {"tenant": tenant, "uuid": this.receipt_object.sreceipt_id, filename: this.receipt_object.name};

                axios.post(process.env.VUE_APP_ENDPOINT_URL +"/downloadFile", post_data, {responseType: 'blob'}).then(response => { 
               
                    const reader = new FileReader();
                    // This fires after the blob has been read/loaded.
                    reader.addEventListener('loadend', (e) => {
                        const text = e.srcElement.result;
                        let chk = true;

                        if(text.includes("<Error>")){
                            chk = false;
                        }

                        if(this.isJsonString(text)){
                            if(JSON.parse(text).hasOwnPropery('success')){
                                if(!JSON.parse(text).success) {
                                    chk = false;
                                }   
                            }
                        }

                        if(chk) {
                            let file_url =  window.URL.createObjectURL(new Blob([response.data], { type: response.headers['content-type'] }));

                            let anchor = document.createElement("a");
                            anchor.href = file_url;
                            anchor.download = this.receipt_object.name;

                            document.body.appendChild(anchor);
                            anchor.click();
                            document.body.removeChild(anchor);

                            URL.revokeObjectURL(file_url);
                        }else{
                            this.alertContent = this.$t("alert-modal.download-issue");
                            return this.isAlertModalVisible = true;
                        }
                    });

                    reader.readAsText(response.data);
                    
                }).catch(err => {
                    this.manageRequestException(err);
                    
                    this.alertContent = this.$t("alert-modal.download-problem")+ err.message;
                    return this.isAlertModalVisible = true;
                });
            },
            isJsonString(str) {
                try {
                    JSON.parse(str);
                } catch (e) {
                    return false;
                }
                return true;
            },
            manageRequestException(err){ 
                if(err=="Error: Network Error"){ 
                    notificationService.sendNotf({"type":"error", "message":"Can't contact the endpoint", "title":"ERROR"});
                    return;
                }else{                        
                    if(err=="Error: Request failed with status code 503"){
                        err = "Request failed.";
                
                    }else if(err=="Error: Request failed with status code 500"){
                        err = "Endpoint internal error."

                    }else if(err=="Error: Request failed with status code 401"){
                        err = "Session expired."
                    }

                    notificationService.sendNotf({"type":"error", "message": err.toString().replace("Error: ", ""), "title":"ERROR"});

                    /*if(err == "Session expired."){
                        setTimeout(() => { 
                            document.location.href = this.siteroot;
                        }, 1000);
                    }*/

                    return;
                }
            }
        }
    }
</script>

<style>
    .wrap-logo #logo {
        height: 60px;
    }
    #wrap-loader {
        margin-top: 30vh;
    }
    .contain-error img {
        opacity: 0.9;
        height: 180px;
        margin-bottom: 50px;
    }
    .contain-error span {
        color: #748a9d;
        font-size: 1rem;
    }
    .contain-error {
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        height: calc(100vh - 200px);
    }
    .title {
        color: #2eb085;
        margin-top: 80px;
        font-size: 1.3rem;
        margin-bottom: 30px;
        text-transform: capitalize;
    }
    .receipt-content {
        height: auto;
        overflow: auto;
        margin-top: 10px;
        margin-left: 20%;
        width: 60%;
        border: 1px solid #ccc;
        padding: 10px 40px 20px 40px;
        max-height: calc(70vh - 100px);
        background-color: whitesmoke;
    }
    .receipt-content .receipt {
        margin-top: 20px;
        color: #595959;
        font-size: 0.75rem;
        margin-bottom: 20px;
        font-family: monospace !important;
    }
    .download-btn {
        display: flex;
        margin-left: 20%;
        width: 60%;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        background-color: #2eb085;
        border: 1px solid #2aa079;
        height: 80px;
        font-size: 1rem;
        color: white;
        cursor: pointer;
    }
    .download-btn:hover {
        font-size: 1.05rem;
        background-color: #2aa079;
        border: 1px solid #228162;
    }
    .download-btn i {
        font-size: 1rem;
        fill: white;
        margin-right: 10px;
        position: relative;
        top: -2px;
    }
    .download-btn:hover i {
        font-size: 1.05rem;
    }


    @media screen and (max-heigth: 800px) {
        .wrap-logo #logo {
            height: 40px;
        }
        .title {
            margin-top: 40px;
            font-size: 1.1rem;
            margin-bottom: 20px;
        }
    }
    @media screen and (max-width: 770px) {
        .receipt-content {
            margin-left: 10%;
            width: 80%;
        }
        .download-btn {
            margin-left: 10%;
            width: 80%;
        }
    }
    @media screen and (max-width: 600px) {
        .receipt-content {
            width: 90%;
            margin-left: 5%;
            padding: 10px 10px 20px 10px;
            /*width: calc(100% - 80px);*/
        }
        .download-btn {
            width: 90%;
            margin-left: 5%;
        }
    }
    @media screen and (max-width: 550px) {
        .wrap-logo #logo {
            height: 40px;
        }
        .title {
            margin-top: 40px;
            font-size: 1.1rem;
            margin-bottom: 20px;
        }
        .download-btn {
            height: 60px;
            font-size: 0.9rem;
        }
    }
    @media screen and (max-width: 400px) { 
        .wrap-logo #logo {
            position: relative;
            height: 35px;
            top: -10px;
        }
        .title {
            margin-top: 20px;
            font-size: 0.9rem;
            margin-bottom: 10px;
        }
        .receipt-content .receipt {
            font-size: 0.60rem;
        }
    }
</style>